import {HttpClient} from '@angular/common/http';
import {Inject, Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {ResourceAllocationTimeWindowExtModel} from "../../models/resource-allocation-time-window-ext.model";

@Injectable({providedIn: 'root'})
export class ResourcesHttpService {

  private base_url = `/resourceAllocations/instancesExt`;

  constructor(@Inject(HttpClient) private http: HttpClient) {
  }

  getResource(id: string): Observable<ResourceAllocationTimeWindowExtModel> {
    return this.http.get<ResourceAllocationTimeWindowExtModel>(`${this.base_url}/${id}`);
  }

  getResources(params?: any): Observable<{ list: ResourceAllocationTimeWindowExtModel[], cursor?: string }> {
    return this.http
      .get<{ list: ResourceAllocationTimeWindowExtModel[], cursor?: string }>(this.base_url, {params});
  }

}
